module.exports = __webpack_public_path__ + "static/android3-8acd28ebfbadebbfad5fedfd1dd1b2a6.jpg";